import { FC } from 'react';
import { DefaultCell } from '@silverfort/sf-components';
import { formatDateToNow } from '../../../../../../utils/dates';

type Props = {
    lastAuthTime: Date;
};

const LastAuthCell: FC<Props> = ({ lastAuthTime }) => {
    const timeAgoText = formatDateToNow(lastAuthTime);
    return <DefaultCell text={timeAgoText} />;
};

export default LastAuthCell;
